export const firstQuestionKey = "anomaly";

export const ANOMALY = {
    DETECTED: "detected",
    NOT_DETECTED: "not_detected"
};

export const TECHNICAL_GUIDE_STATE = {
    NONE: "none",
    HELPFUL: "helpful",
    NOT_HELPFUL: "not_helpful"
};

export const PAUSE_REQUEST = {
    NONE: "none",
    DAYS_7: "7_days",
    DAYS_14: "14_days",
    DAYS_30: "30_days",
    DAYS_90: "90_days"
};

const FOLLOWUP_QUESTION = "followupQuestion"; // this is used for a value that is only used to trigger a follow-up question

export const questions: QuestionsObject = {
    anomaly: {
        name: "anomaly",
        labelKey: "serviceCase.proactiveCaseClosure.question.anomaly",
        options: {
            [ANOMALY.DETECTED]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "technicalGuideLinked" },
            [ANOMALY.NOT_DETECTED]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    technicalGuideLinked: {
        name: "technicalGuideLinked",
        labelKey: "serviceCase.proactiveCaseClosure.question.technicalGuideLinked",
        options: {
            [FOLLOWUP_QUESTION]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "technicalGuideHelpful" },
            [TECHNICAL_GUIDE_STATE.NONE]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    technicalGuideHelpful: {
        name: "technicalGuideHelpful",
        labelKey: "serviceCase.proactiveCaseClosure.question.technicalGuideHelpful",
        options: {
            [TECHNICAL_GUIDE_STATE.HELPFUL]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "pauseRequest" },
            [TECHNICAL_GUIDE_STATE.NOT_HELPFUL]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no", next: "pauseRequest" }
        }
    },
    pauseRequest: {
        name: "pauseRequest",
        labelKey: "serviceCase.proactiveCaseClosure.question.pauseRequest",
        options: {
            [FOLLOWUP_QUESTION]: { labelKey: "serviceCase.proactiveCaseClosure.answers.yes", next: "pauseRequestDuration" },
            [PAUSE_REQUEST.NONE]: { labelKey: "serviceCase.proactiveCaseClosure.answers.no" }
        }
    },
    pauseRequestDuration: {
        name: "pauseRequestDuration",
        labelKey: "serviceCase.proactiveCaseClosure.question.pauseRequestDuration",
        options: {
            [PAUSE_REQUEST.DAYS_7]: { labelKey: "serviceCase.proactiveCaseClosure.answers.sevenDays" },
            [PAUSE_REQUEST.DAYS_14]: { labelKey: "serviceCase.proactiveCaseClosure.answers.fourteenDays" },
            [PAUSE_REQUEST.DAYS_30]: { labelKey: "serviceCase.proactiveCaseClosure.answers.thirtyDays" },
            [PAUSE_REQUEST.DAYS_90]: { labelKey: "serviceCase.proactiveCaseClosure.answers.ninetyDays" }
        },
        comment: {
            name: "comment",
            labelKey: "serviceCase.proactiveCaseClosure.question.comment",
            placeholderKey: "serviceCase.proactiveCaseClosure.question.commentPlaceholder"
        }
    }
};

type Anomaly = (typeof ANOMALY)[keyof typeof ANOMALY];
type TechnicalGuideState = (typeof TECHNICAL_GUIDE_STATE)[keyof typeof TECHNICAL_GUIDE_STATE];
type PauseRequest = (typeof PAUSE_REQUEST)[keyof typeof PAUSE_REQUEST];

export interface RequestData {
    // token: string; // the token is added by the request function
    callId: string;
    anomaly?: Anomaly;
    technicalGuideState: TechnicalGuideState;
    pauseRequest: PauseRequest;
    comment: string | null;
}

export const buildRequestData = (
    { anomaly, technicalGuideHelpful, technicalGuideLinked, pauseRequest, pauseRequestDuration, comment }: Answers,
    callId: string
): RequestData => {
    return {
        callId,
        anomaly,
        technicalGuideState:
            (technicalGuideLinked !== FOLLOWUP_QUESTION ? technicalGuideLinked : technicalGuideHelpful) ||
            TECHNICAL_GUIDE_STATE.NONE,
        pauseRequest: (pauseRequest !== FOLLOWUP_QUESTION ? pauseRequest : pauseRequestDuration) || PAUSE_REQUEST.NONE,
        comment: comment || null
    };
};

interface QuestionsObject {
    [key: string]: Question;
}

export interface Question {
    name: string;
    labelKey: string;
    options: Options;
    comment?: Comment;
}

export interface Comment {
    name: string;
    labelKey: string;
    placeholderKey: string;
}

interface Options {
    [key: string]: Option;
}

export interface Option {
    labelKey: string;
    next?: string;
}

export interface Answers {
    anomaly?: Anomaly;
    technicalGuideLinked?: string;
    technicalGuideHelpful?: string;
    pauseRequest?: string;
    pauseRequestDuration?: string;
    comment?: string;
}
